import React from "react";
import Image from "next/image";
import logo from "../assets/logo.png";
import { useRouter } from "next/router";
import Link from "next/link";

// The vanity invite. Note other invite codes exist in the codebase
// (discord.gg/pBnz7CUwNW in ios.js, discord.gg/uURqJ9w4c3 in IosBETA) - this
// is the canonical one, already used by app.js and link/discord.js.
const DISCORD_URL = "https://discord.gg/jammable";

const COLUMNS = [
  {
    title: "Create",
    items: [
      { title: "AI Cover Generator", url: "/ai-cover" },
      { title: "AI Voice Changer", url: "/ai-voice-changer" },
      { title: "AI Voice Library", url: "/models" },
      { title: "Train a Voice", url: "/train" },
    ],
  },
  {
    title: "Jammable",
    items: [
      { title: "Pricing", url: "/pricing" },
      { title: "Library", url: "/library" },
      { title: "Settings", url: "/settings" },
      { title: "Earn with Jammable", url: "/earn" },
      { title: "API", url: "/docs" },
      { title: "MCP Server for AI Agents", url: "/mcp" },
    ],
  },
  {
    title: "Account",
    items: [
      { title: "Log in", url: "/login" },
      { title: "Sign up", url: "/signup" },
      { title: "Forgot password", url: "/forgotpassword" },
    ],
  },
  {
    title: "Legal",
    items: [
      { title: "Terms of Use", url: "/terms" },
      { title: "Privacy Policy", url: "/privacy" },
      { title: "DMCA Policy", url: "/dmca-policy" },
      { title: "Refund Policy", url: "/refunds" },
    ],
  },
];

const footerVisible = [
  "/",
  "/settings",
  "/help",
  "/privacy",
  "/terms",
  "/[model]",
  "/new/[model]",
  "/models",
  "/ai-cover",
  "/ai-voice-changer",
  "/trainmodel",
  "/refunds",
  "/tiktokchallenge",
  "/tiktokchallenge/terms",
  "/community",
  "/custommodels",
  "/affiliate/terms",
  "/earn",
  "/tools",
  "/tools/[tool]",
  "/pricing",
  "/community/[id]",
  "/user/[id]",
  "/dmca-policy",
  "/presets/[effect]",
  "/shop",
  "/train",
  "/collection/[collectionid]",
  "/@/[id]",
  "/library",
  "/dashboard",
  "/dashboard/[songid]",
];

const PageFooter = () => {
  const router = useRouter();
  if (!footerVisible.includes(router.pathname)) return null;

  return (
    <footer className="tw-mt-16 tw-bg-jam-lav tw-pb-28 md:tw-pb-0">
      <div className="tw-mx-auto tw-grid tw-max-w-[1280px] tw-grid-cols-2 tw-gap-8 tw-px-4 tw-py-12 md:tw-grid-cols-[1.4fr_1fr_1fr_1fr_1fr] md:tw-px-8">
        <div className="tw-col-span-2 tw-flex tw-flex-col tw-gap-3.5 md:tw-col-span-1">
          <Link
            href="/"
            className="tw-flex tw-items-center tw-gap-2.5 tw-text-jam-ink tw-no-underline"
          >
            <Image src={logo} width={32} height={32} alt="Jammable" />
            <span className="jam-display tw-text-[22px] tw-font-extrabold">
              Jammable
            </span>
          </Link>
          <p className="tw-m-0 tw-max-w-[280px] tw-text-sm tw-font-semibold tw-text-jam-muted">
            AI covers with 100,000+ voices. Make one in seconds.
          </p>
          <a
            href={DISCORD_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="tw-self-start tw-rounded-full tw-bg-[#5865F2] tw-px-4 tw-py-2.5 tw-text-[13px] tw-font-extrabold tw-text-white tw-no-underline"
          >
            Join our Discord
          </a>
        </div>
        {COLUMNS.map((col) => (
          <div key={col.title} className="tw-flex tw-flex-col tw-gap-2.5">
            <span className="tw-text-xs tw-font-extrabold tw-uppercase tw-tracking-wider tw-text-jam-muted">
              {col.title}
            </span>
            {col.items.map((item) => (
              <Link
                key={item.url}
                href={item.url}
                className="tw-text-sm tw-font-bold tw-text-jam-ink tw-no-underline hover:tw-text-jam-purple"
              >
                {item.title}
              </Link>
            ))}
          </div>
        ))}
      </div>
      <div className="tw-mx-auto tw-flex tw-max-w-[1280px] tw-flex-col tw-gap-1 tw-px-4 tw-pb-8 tw-text-[13px] tw-font-semibold tw-text-jam-muted md:tw-px-8">
        <span>{`© ${new Date().getFullYear()} Jammable Limited`}</span>
        <span>
          Uses{" "}
          <a
            href="https://pitchmeld.ing/"
            target="_blank"
            rel="noopener noreferrer"
            className="tw-text-jam-muted tw-underline"
          >
            Pitchmeld technology
          </a>{" "}
          for voice processing
        </span>
      </div>
    </footer>
  );
};

export default PageFooter;
